module.exports = "<customers-page></customers-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appCustomers/index.html
// module id = 193
// module chunks = 0